module.exports = __webpack_public_path__ + "img/Repair.6ac1357a.png";